mutation DeletePromocodes($ids: [ID!]!) {
  deletePromocodes(ids: $ids)
}
